import { StyledEngineProvider } from '@mui/material/styles';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './components/omegaRoutes/AppRoutes';

function App() {
    return (
        <div className="App">
            <StyledEngineProvider injectFirst>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </StyledEngineProvider>
            <div className="landscape-message">
                    <h1>Please switch to landscape mode for a better viewing experience.</h1>
                </div>
        </div>
    );
}

export default App;
